import { render, staticRenderFns } from "./FCCCompetitorDetails.vue?vue&type=template&id=b1af4e4a"
import script from "./FCCCompetitorDetails.vue?vue&type=script&lang=js"
export * from "./FCCCompetitorDetails.vue?vue&type=script&lang=js"
import style0 from "./FCCCompetitorDetails.vue?vue&type=style&index=0&id=b1af4e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports